import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { forgotPassword } from "../lib/adminApi";
import Logo from "../components/Logo";

export default function AdminForgot() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email, window.location.origin);
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Une erreur est survenue");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-forgot-page" className="min-h-screen flex items-center justify-center bg-navy px-5">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-8">
          <Logo className="h-10 w-10" light />
          <span className="font-display font-bold text-xl text-white">TIRERA GROUP</span>
        </div>
        <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-8">
          {sent ? (
            <div data-testid="admin-forgot-success" className="text-center">
              <CheckCircle2 size={44} className="text-africain mx-auto" />
              <h1 className="mt-4 font-display font-semibold text-xl text-white">Email envoyé</h1>
              <p className="mt-2 text-sm text-white/60">
                Si un compte correspond à cet email, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte de réception (et les spams).
              </p>
              <Link to="/admin/login" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white hover:text-white/80">
                <ArrowLeft size={16} /> Retour à la connexion
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="admin-forgot-form">
              <div className="flex items-center gap-2 text-white/60 text-xs font-semibold uppercase tracking-wider">
                <Mail size={14} /> Mot de passe oublié
              </div>
              <h1 className="mt-3 font-display font-semibold text-2xl text-white">Réinitialiser</h1>
              <p className="mt-2 text-sm text-white/60">Saisissez votre email administrateur pour recevoir un lien de réinitialisation.</p>
              <label className="mt-6 block text-sm font-medium text-white/80">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-forgot-email"
                className="mt-2 w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-white placeholder-white/40 outline-none focus:border-white/40"
                placeholder="email@exemple.com"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="admin-forgot-submit"
                className="mt-6 w-full rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-navy hover:bg-white/90 transition-colors disabled:opacity-60"
              >
                {loading ? "Envoi…" : "Envoyer le lien"}
              </button>
              <Link to="/admin/login" className="mt-4 flex items-center justify-center gap-2 text-sm text-white/60 hover:text-white">
                <ArrowLeft size={15} /> Retour à la connexion
              </Link>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
